export default __webpack_public_path__ + "static/media/Rajdeep Bose.d10b99a9.jpg";